import { SvgIcon, SvgIconProps } from '@mui/material'

export function HamburgerIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1499 3.98328C2.1499 3.70713 2.37376 3.48328 2.6499 3.48328H13.3166C13.5927 3.48328 13.8166 3.70713 13.8166 3.98328C13.8166 4.25942 13.5927 4.48328 13.3166 4.48328H2.6499C2.37376 4.48328 2.1499 4.25942 2.1499 3.98328Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1499 7.98328C2.1499 7.70713 2.37376 7.48328 2.6499 7.48328H13.3166C13.5927 7.48328 13.8166 7.70713 13.8166 7.98328C13.8166 8.25942 13.5927 8.48328 13.3166 8.48328H2.6499C2.37376 8.48328 2.1499 8.25942 2.1499 7.98328Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1499 11.9833C2.1499 11.7071 2.37376 11.4833 2.6499 11.4833H13.3166C13.5927 11.4833 13.8166 11.7071 13.8166 11.9833C13.8166 12.2594 13.5927 12.4833 13.3166 12.4833H2.6499C2.37376 12.4833 2.1499 12.2594 2.1499 11.9833Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default HamburgerIcon